"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isPaused = (flow) => {
    return flow.paused;
};
exports.default = isPaused;
